import { MealPlanningSessionDetail } from "@corpuscomplete/core-ui/nutrition/meal-planning-session/detail";
import { MealPlanningSessionDetailPage } from "@corpuscomplete/web/modules/nutrition/meal-planning-session/pages/meal-planning-session-detail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/meal-planning-sessions/$id")({
  loader: async ({ context, params }) => {
    if (context.zero) {
      MealPlanningSessionDetail.preload(context.zero, { id: params.id });
    }
  },
  component: () => {
    const { id } = Route.useParams();
    return <MealPlanningSessionDetailPage id={id} />;
  },
});
